<template>
    <div class="dayOffPage">
        <div>
            <h2>Leave status</h2>
            <div class="summaryData">
                <div class="summary-row">
                    <p class="summaryTitle">Annual leave</p>
                    <div class="daysDetailWrap">
                        <div class="daysDetail" v-if="entitlementDays !== null">
                            <p>Base</p>
                            <p>
                                {{ entitlementDays }}<br /><span class="days-unit">days</span>
                            </p>
                        </div>
                        <div class="daysDetail" v-if="usedLeaveDays !== null">
                            <p>Used</p>
                            <p>
                                {{ usedLeaveDays }}<br /><span class="days-unit">days</span>
                            </p>
                        </div>
                        <div class="daysDetail" v-if="remainingLeaveDays !== null">
                            <p>Remain</p>
                            <p>
                                {{ remainingLeaveDays }}<br /><span class="days-unit"
                                >days</span
                                >
                            </p>
                        </div>
                    </div>
                </div>
                <div class="summary-row" v-if="carryoverDaysDisplay !== null">
                    <p class="summaryTitle">Carryover</p>
                    <div class="daysDetailWrap">
                        <div class="daysDetail" v-if="carryoverDays !== null">
                            <p>Total</p>
                            <p>
                                {{ carryoverDays }}<br /><span class="days-unit">days</span>
                            </p>
                        </div>
                        <div class="daysDetail" v-if="usedCarryoverDays !== null">
                            <p>Used</p>
                            <p>
                                {{ usedCarryoverDays }}<br /><span class="days-unit">days</span>
                            </p>
                        </div>
                        <div class="daysDetail" v-if="remainingCarryoverDays !== null">
                            <p>Remain</p>
                            <p>
                                {{ remainingCarryoverDays }}<br /><span class="days-unit">days</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="summary-row">
                    <p class="summaryTitle">Holiday in Lieu days</p>
                    <div class="daysDetailWrap">
                        <div class="daysDetail" v-if="compensatoryAccrualDays !== null">
                            <p>Total</p>
                            <p>
                                {{ toFixed2Floor(compensatoryAccrualDays) }}<br /><span
                                class="days-unit"
                                >days</span
                                >
                            </p>
                        </div>
                        <div class="daysDetail" v-if="compensatoryUsedDays !== null">
                            <p>Used</p>
                            <p>
                                {{ toFixed2Floor(compensatoryUsedDays) }}<br /><span
                                class="days-unit"
                                >days</span
                                >
                            </p>
                        </div>
                        <div class="daysDetail" v-if="compensatoryRemainingDays !== null">
                            <p>Remain</p>
                            <p>
                                {{ toFixed2Floor(compensatoryRemainingDays) }}<br /><span
                                class="days-unit"
                                >days</span
                                >
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="submHistWrap">
            <div class="submitWrap">
                <h2>Apply for leave</h2>
                <form @submit.prevent="submitApplication">
                    <div class="form-group">
                        <label for="start-date">Start Date *</label>
                        <input
                        type="date"
                        id="start-date"
                        v-model="startDate"
                        :min="minDate"
                        :max="maxDate"
                        @change="handleDateChange"
                        required
                        />
                    </div>
                    <div class="form-group">
                        <label for="end-date">End Date *</label>
                        <input
                        type="date"
                        id="end-date"
                        v-model="endDate"
                        :min="startDate"
                        :max="maxDate"
                        @change="handleDateChange"
                        required
                        />
                    </div>
                    <div v-if="dateError" class="error-message">{{ dateError }}</div>
                    <div class="form-group">
                        <label for="paidcomp-type">Holiday Type *</label>
                        <select id="paidcomp-type" v-model="paidcompType">
                            <option value="Paid">Paid Holiday</option>
                            <option v-if="carryoverDaysDisplay && carryoverDaysDisplay > 0" value="Carryover">Carry-over</option>
                            <option value="Comp">Holiday in Lieu</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="leave-type">Period *</label>
                        <select id="leave-type" v-model="leaveType">
                            <option value="Full">Holiday</option>
                            <option value="Morning">AM Holiday</option>
                            <option value="Afternoon">PM Holiday</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="reason">Reason</label>
                        <textarea
                        id="reason"
                        v-model="reason"
                        placeholder=""
                        rows="3"
                        ></textarea>
                    </div>
                    <button type="submit">Submit</button>
                </form>
                <div v-if="message" class="message">{{ message }}</div>
            </div>
            <div class="submitHistory">
                <h2>Leave history</h2>
                <div v-if="loadingApplications">Loading...</div>
                <div v-else-if="applicationsError" class="error">
                    {{ applicationsError }}
                </div>
                <div v-else class="applications-table">
                    <div v-for="app in applications" :key="app.id" class="historyPart">
                        <div>
                            <span
                            :class="{
                                submitStatus: true,
                                status: true,
                                statusPending: app.status === 'PENDING',
                                statusApproved: app.status === 'APPROVED',
                                statusRejected: app.status === 'REJECTED',
                            }"
                            >{{ displayStatus(app.status) }}
                        </span>
                        <span class="paidCompType">
                        {{ 
                            app.paidcomp_type_display === "Compensatory Off"
                                  ? "Holiday in Lieu"
                                  : app.paidcomp_type_display === "Paid Off"
                                    ? "Paid Holiday"
                                    : app.paidcomp_type_display
                        }}
                    </span><br />
                        <span>
                            <template
                            v-if="Array.isArray(app.dates) && app.dates.length > 1"
                            >
                            {{ formatDateUK(app.dates[0].date) }} -
                            {{ formatDateUK(app.dates[app.dates.length - 1].date) }}
                        </template>

                        <template
                        v-else-if="Array.isArray(app.dates) && app.dates.length === 1"
                        >
                        {{ formatDateUK(app.dates[0].date) }}
                    </template>
                </span>
                <span v-if='displayLeaveType(app.leave_type) !=="Full"'>&nbsp;{{ displayLeaveType(app.leave_type) }}</span>
                <div class="reason">{{ app.reason || "" }}</div>
                <p class="submitDate">
                  <span v-if="app.approved_by_name">{{ app.approved_by_name }} | </span>
                  <span>{{ formatDateTime(app.applied_at) }}</span>
                </p>
            </div>
        </div>
        <div v-if="applications.length === 0">
            No application history yet.
        </div>
    </div>
</div>
</div>
</div>
</template>

<script>
import api, { applyDayOff, setAuthToken, fetchProfile } from "@/services/api";
import notificationService from "@/services/notificationService";

export default {
  name: "HolidayApplicationView",
  props: {
    showApprovalsTab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const today = this.$now().toISOString().slice(0, 10);
    return {
      startDate: today,
      endDate: today,
      leaveType: "Full",
      paidcompType: "Paid",
      message: "",
      applications: [],
      loadingApplications: false,
      applicationsError: "",
      entitlementDays: null,
      carryoverDays: null,
      usedCarryoverDays: null, // Add this
      usedLeaveDays: null,
      reason: "",
      compensatoryAccrualDays: null, // Added
      compensatoryUsedDays: null, // Added
      holidays: [],
      dateError: "",
    };
  },
  computed: {
    currentFiscalYear() {
        const today = this.$now();
        const year = today.getFullYear();
        const month = today.getMonth() + 1; // 1-12
        return month >= 4 ? year : year - 1;
    },
    requiredCompDays() {
      return this.leaveType === "Full" ? 1 : 0.5;
    },
    compensatoryRemainingDays() {
      if (
        this.compensatoryAccrualDays !== null &&
        this.compensatoryUsedDays !== null
      ) {
        return this.compensatoryAccrualDays - this.compensatoryUsedDays;
      }
      return null;
    },
    remainingLeaveDays() {
      if (this.entitlementDays !== null && this.usedLeaveDays !== null) {
        return this.entitlementDays - this.usedLeaveDays;
      }
      return null;
    },
    remainingCarryoverDays() {
        if (this.carryoverDays !== null && this.usedCarryoverDays !== null) {
            return this.carryoverDays - this.usedCarryoverDays;
        }
        return null;
    },
    carryoverDaysDisplay() {
      // 4/1～6/30のみcarryoverDaysを表示
      const today = this.$now();
      const month = today.getMonth() + 1; // 0-indexed
      const day = today.getDate();
      if (month === 4 || month === 5 || (month === 6 && day <= 30)) {
        // 繰越残高 = 繰越日数 - 繰越消化日数
        return this.carryoverDays - this.usedCarryoverDays;
      }
      return null;
    },
    minDate() {
      return this.$now().toISOString().slice(0, 10);
    },
    maxDate() {
      const today = this.$now();
      let year = today.getFullYear();
      // If fiscal year starts from April 1st
      if (today.getMonth() >= 3) {
        // 0-indexed month, so March is 2, April is 3
        year++;
      }
      return new Date(year, 2, 31).toISOString().slice(0, 10); // March 31st of next fiscal year
    },
  },
  methods: {
    handleDateChange() {
      this.dateError = this.validateDate(this.startDate) || this.validateDate(this.endDate);
    },

    async submitApplication() {
      this.dateError = this.validateDate(this.startDate) || this.validateDate(this.endDate);
      if (this.dateError) {
        alert(this.dateError);
        return;
      }

      if (this.paidcompType === 'Carryover') {
        const today = this.$now();
        const currentYear = today.getFullYear();
        const deadline = new Date(currentYear, 5, 30); // Month is 0-indexed, so 5 is June

        if (new Date(this.endDate) > deadline) {
          alert('Carry-over can only be used until June 30th of the current year.');
          return;
        }
      }

      if (!this.startDate || !this.endDate) {
        alert("Start date and end date are required.");
        return;
      }
      if (this.startDate > this.endDate) {
        alert("Start date must be before end date.");
        return;
      }
      if (
        this.paidcompType === "Comp" &&
        this.compensatoryRemainingDays < this.requiredCompDays
      ) {
        alert(
          `Insufficient compensatory days (Required: ${this.requiredCompDays} days, Remaining: ${this.compensatoryRemainingDays} days)`
        );
        return;
      }
      try {
        const payload = {
          start_date: this.startDate,
          end_date: this.endDate,
          leave_type: this.leaveType,
          paidcomp_type: this.paidcompType,
          reason: this.reason,
        };
        await applyDayOff(payload);
        alert("Application submitted successfully.");
        window.location.reload(); // Add this line

        this.startDate = "";
        this.endDate = "";
        this.leaveType = "Full";
        await this.fetchApplications();
        if (this.paidcompType === "Paid") {
          await this.fetchProfile();
        }
        this.reason = "";
        await this.fetchCompensatoryBalance();
      } catch (error) {
        // If 400 is returned due to duplicate checks, alert that message
        if (error.response && error.response.status === 400) {
          const data = error.response.data;
          // DRF ValidationError is expected to be in non_field_errors
          const msg =
            data.non_field_errors?.[0] || data.detail || "Application failed.";
          alert(msg);
        } else {
          alert("Server error occurred during application.");
        }
      }
    },
    async fetchApplications() {
      this.loadingApplications = true;
      this.applicationsError = "";
      try {
        const res = await api.get("/leave/applications/");
        this.applications = res.data;
      } catch (error) {
        console.error(
          "Failed to fetch application list:",
          error.response || error
        );
        this.applicationsError = "Failed to fetch application list.";
      } finally {
        this.loadingApplications = false;
      }
    },
    async fetchProfile() {
      try {
        const res = await fetchProfile();
        // JSON に含まれる各フィールドを data に反映
        // CustomUser のプロファイル情報のみを扱う
        // 有給残高は fetchPaidLeaveBalance で取得
      } catch (err) {
        console.error("Failed to fetch profile:", err);
      }
    },
    async fetchPaidLeaveBalance() {
      try {
        const res = await api.get("/leave-balance/paidleaves/", {
          params: {
            fiscal_year: this.currentFiscalYear,
          },
        });
        const paidLeaveData = res.data[0]; // The API now returns a single-item array or empty
        if (paidLeaveData) {
          this.entitlementDays = paidLeaveData.total_days;
          this.usedLeaveDays = paidLeaveData.used_days;
          this.carryoverDays = paidLeaveData.carryover_days;
          this.usedCarryoverDays = paidLeaveData.used_carryover_days;
        } else {
          // データがない場合のデフォルト値
          this.entitlementDays = 0;
          this.usedLeaveDays = 0;
          this.carryoverDays = 0;
          this.usedCarryoverDays = 0;
        }
      } catch (err) {
        console.error(
          "Failed to fetch paid leave balance:",
          err.response?.data || err
        );
        this.entitlementDays = null;
        this.usedLeaveDays = null;
        this.carryoverDays = null;
        this.usedCarryoverDays = null;
      }
    },
    async fetchCompensatoryBalance() {
      try {
        const res = await api.get("/leave-balance/compbalances/", {
          params: {
            fiscal_year: this.currentFiscalYear,
          },
        });
        const list = res.data;
        if (Array.isArray(list) && list.length > 0) {
          this.compensatoryAccrualDays = list[0].accrual_days;
          this.compensatoryUsedDays = list[0].used_days;
        } else {
          this.compensatoryAccrualDays = 0;
          this.compensatoryUsedDays = 0;
        }
      } catch (err) {
        console.error("Failed to fetch compensatory days:", err);
        this.compensatoryAccrualDays = null;
        this.compensatoryUsedDays = null;
      }
    },

    async fetchHolidays() {
      try {
        const res = await api.get("/common/holidays/");
        this.holidays = res.data.map(h => h.date);
      } catch (err) {
        console.error("Failed to fetch holidays:", err);
      }
    },

    validateDate(dateStr) {
      const date = new Date(dateStr);
      const day = date.getUTCDay();
      if (day === 0 || day === 6) {
        return "Date cannot be on a weekend.";
      }
      if (this.holidays.includes(dateStr)) {
        return "Date cannot be on a holiday.";
      }
      return "";
    },

    // Helper for label conversion and date/time formatting omitted
    displayLeaveType(code) {
      switch (code) {
        case "Full":
          return "Full";
        case "Morning":
          return "AM ";
        case "Afternoon":
          return "PM ";
        default:
          return code;
      }
    },
    displayStatus(status) {
      switch (status) {
        case "PENDING":
          return "PENDING";
        case "APPROVED":
          return "APPROVED";
        case "REJECTED":
          return "REJECTED";
        default:
          return status;
      }
    },
    formatDateTime(dt) {
      if (!dt) return "";
      const d = new Date(dt);
      // イギリス式: dd/MM/yyyy HH:mm
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      const hour = String(d.getHours()).padStart(2, "0");
      const min = String(d.getMinutes()).padStart(2, "0");
      return `${day}/${month}/${year} ${hour}:${min}`;
    },
    toFixed2Floor(val) {
      if (typeof val !== "number") return val;
      return Math.floor(val * 100) / 100;
    },
    formatDateUK(dateStr) {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
  },
  async mounted() {
    // Set token
    const token = sessionStorage.getItem("token");
    if (token) {
      setAuthToken(token);
      await this.fetchApplications();
      await this.fetchPaidLeaveBalance(); // fetchProfile の代わりに呼び出す
      await this.fetchCompensatoryBalance();
      await this.fetchHolidays();
    } else {
      this.message = "You are not logged in.";
      this.$router.push("/");
    }
  },
};
</script>

<style scoped>
.dayOffPage {
  h2 {
    margin-bottom: 3vh;
  }
  & .summaryData {
    border-bottom: 1px dashed var(--blue);
    margin-bottom: 3vh;
    padding-bottom: 5vh;
    display: flex;

    & > div {
      width: 300px;
      border: 1px solid var(--lightBlue);
      border-radius: 10px;
      text-align: center;
      margin-right: 1rem;
      & p {
        color: var(--blue);
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
  .carryOver > p:first-child {
    background: var(--lightBlue);
    padding: 1rem;
    margin: 0;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
  }
}
.daysDetailWrap {
  display: flex;
  & .daysDetail {
    width: 33%;
  }
  & .daysDetail:not(:last-child) {
    border-right: 1px dashed var(--midLightBlue);
  }
}
.summaryTitle {
  margin: 0;
  padding: 0.6rem 0;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  background: var(--lightBlue);
}

.submHistWrap {
  display: flex;

  & h2 {
    margin-top: 3vh;
  }
}
.submitWrap {
  width: 60%;
  border-right: 1px dashed var(--blue);
  margin-right: 2vw;
  padding-right: 2vw;

  & label {
    color: var(--blue);
    display: inline-block;
    width: 110px;
  }
  & input,
  & select,
  & textarea {
    color: var(--blue);
    padding: 1rem;
    border: 1px solid #aeaeae;
    border-radius: 5px;
  }
  & textarea {
    width: calc(100% - 135px);
  }
  & button {
    background: var(--grad90);
    width: 100%;
    padding: 1rem;
    border: none;
    color: white;
    border-radius: 10px;
  }
}

.submitHistory {
  width: 40%;
  & span {
    color: var(--blue);
    line-height: 1.5;
  }
  & .historyPart {
    border-top: 1px solid var(--lightBlue);
    margin-top: 0.5rem;
    padding-top: 0.5rem;
  }
  & .submitDate {
    color: var(--midLightBlue);
    font-size: 12px;
    margin: 0;
    text-align: right;
  }
  & .submitStatus {
    color: white;
    font-size: 10px;
    padding: 0.2rem;
    margin-right: 0.3rem;
    border-radius: 5px;
  }
  & .statusPending {
    border: 1px solid var(--green);
    color: var(--green);
  }
  & .statusApproved {
    background: var(--blue);
  }
  & .statusRejected {
    background: var(--red);
  }
  & .applications-table {
    max-height: 400px;
    overflow-y: auto;
  }

  & .paidCompType {
    margin-top: 0.2rem;
    display: inline-block;
  }
}

.form-group {
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
}
.message {
  margin-top: 1rem;
  color: green;
}

.error-message {
  color: red;
  margin-top: 1rem;
}

.days-unit {
  display: block;
  font-size: 12px;
  line-height: 1.2;
  font-weight: 500;
}

@media (max-width: 768px) {
  .dayOffPage {
    & .summaryData {
      overflow: scroll;
      & > div {
        min-width: 60vw;
      }
    }
  }
  .daysDetailWrap {
    width: stretch;
    justify-content: space-evenly;
  }
  .daysDetail {
    & > p {
      font-size: 12px !important;
    }
  }
  & .summaryData > div > p > span {
    font-size: 10px;
  }
  .submHistWrap {
    flex-direction: column;
  }
  .submitWrap {
    border-right: none;
    border-bottom: 1px dashed var(--blue);
    margin-right: 0;
    padding-right: 0;
    margin-bottom: 2vh;
    padding-bottom: 5vh;
    width: 100%;
  }
  .submitHistory {
    width: 100%;
    & .applications-table {
      max-height: inherit;
    }
  }
}
</style>
